// src/api/school.js
import request from '@/utils/request'

// api接口列表
const api = {
	nation: 'nation',
	headuser: 'index',
	footer: 'foot/info',
	regions: 'regions',
	senior: 'senior/school',
	saveexam: 'examinfo/save',
	examinfo: 'examinfo',
	province: 'regions/province',
	preprovince: 'regions/province/list',
	banner: 'banner',
	bannerDetail: 'banner/detail',
	helpL: 'question/list',
	helpD: 'question/detail',
	search: 'search/info',
	saveplan: 'education/plan/save',
	entryscore: 'examinfo/entry/score',

}


// 获取民族列表
export function nation(params) {
	return request({
		url: api.nation,
		method: 'get',
		params
	})
}

// 获取首页头部用户信息
export function headuser(params) {
	return request({
		url: api.headuser,
		method: 'get',
		params
	})
}


export function footer(params) {
	return request({
		url: api.footer,
		method: 'get',
		params
	})
}

// 获取省市区
export function regions(params) {
	return request({
		url: api.regions,
		method: 'get',
		params
	})
}

// 根据省市区id获取高中学校
export function senior(params) {
	return request({
		url: api.senior,
		method: 'get',
		params
	})
}

// 高考信息完善
export function saveexam(data) {
	return request({
		url: api.saveexam,
		method: 'post',
		data
	})
}

// 获取考生高考信息
export function examinfo(params) {
	return request({
		url: api.examinfo,
		method: 'get',
		params
	})
}

// 获取省份列表信息
export function province(params) {
	return request({
		url: api.province,
		method: 'get',
		params
	})
}
// 获取获取省份列表-是否配置
export function preprovince(params) {
	return request({
		url: api.preprovince,
		method: 'get',
		params
	})
}


// 获取banner
export function banner(params) {
	return request({
		url: api.banner,
		method: 'get',
		params
	})
}

// 获取banner详情
export function bannerDetail(params) {
	return request({
		url: api.bannerDetail,
		method: 'get',
		params
	})
}


// 常见问题列表
export function helpL(params) {
	return request({
		url: api.helpL,
		method: 'get',
		params
	})
}

// 常见问题详情
export function helpD(params) {
	return request({
		url: api.helpD,
		method: 'get',
		params
	})
}

export function search(params) {
	return request({
		url: api.search,
		method: 'get',
		params
	})
}

// 个人信息保存
export function saveplan(data) {
	return request({
		url: api.saveplan,
		method: 'post',
		data
	})
}

// 录入成绩
export function entryscore(data) {
	return request({
		url: api.entryscore,
		method: 'post',
		data
	})
}